/* esm.sh - applesauce-relay@5.2.0/dist/operators/mark-from-relay */
export * from "/*applesauce-relay@5.2.0/esnext/dist/operators/mark-from-relay.mjs";
